module.exports = __webpack_public_path__ + "img/06.198aa452.jpg";